import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const FakeCounter: React.FC = () => {
  const { t } = useTranslation('landing');
  const [count, setCount] = useState(() => Math.floor(Math.random() * 41) + 820);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCount((prev) => prev + 1);
        setVisible(true);
      }, 200);
    }, Math.random() * 5000 + 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center gap-2 text-orange-400 font-medium">
      <span role="img" aria-label={t('fireAriaLabel')}>&#x1F525;</span>
      <span
        className="transition-opacity duration-200"
        style={{ opacity: visible ? 1 : 0 }}
      >
        <Trans i18nKey="counter" ns="landing" values={{ count }} components={{ 1: <strong /> }} />
      </span>
    </div>
  );
};

export default FakeCounter;
